import { render, staticRenderFns } from "./main.vue?vue&type=template&id=51e21aa6&"
import script from "../ts/main.ts?vue&type=script&lang=js&"
export * from "../ts/main.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports